<template>
  <div class="absolute top-14 right-4">
    <div class="relative h-full">
      <div
        class="v-modal-bg-default box-shadow-bh"
        @click="onClickCancel()"
      ></div>
      <div class="flex justify-center w-full h-full items-center">
        <div class="z-model bg-white p-3 box-shadow-bh">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bh-model",

  data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {
    onHideModelBg() {
      this.$emit("onHideModel", false);
    },

    onClickCancel() {
      this.$emit("onHideModel", false);
    },

    onClickSave() {
      this.$emit("onSaveModel", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.z-model {
  z-index: 888;
  width: 25rem;
  border-radius: 20px;
}

.border-rou {
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
</style>
